const placeRightBelow = (function (_ref) {
  const { gap } = _ref
  const { frameWidth } = _ref
  const { frameLeft } = _ref
  const { boxWidth } = _ref
  const { selectionWidth } = _ref
  const { selectionTop } = _ref
  const { selectionLeft } = _ref
  const { selectionHeight } = _ref

  const style = { position: 'fixed' }
  style.left = selectionLeft + (selectionWidth / 2) - (boxWidth / 2)
  style.top = selectionTop + selectionHeight + gap
  const topPos = document.querySelector('.control-wrapper').offsetHeight -
    document.querySelector('.bookreader-mobile-mobile-nav').offsetHeight
  if (topPos > style.top) {
    style.opacity = 0
  } else {
    style.opacity = 1
  }

  // if the popover is placed too far to the right, align with right edge
  if (style.left < frameLeft) {
    style.left = frameLeft
    // if the popover is placed beyond the right edge align with the
    // right edge of the sceen
  } else if (style.left + boxWidth > frameWidth) {
    style.left = frameWidth - boxWidth
  }

  // if the popover is placed below the frame, position above
  // selection instead if there's room
  // if (style.top + boxHeight > frameHeight && selectionTop - (gap + boxHeight) > frameTop) {
  //   style.top = selectionTop - (gap + boxHeight)
  // }

  return style
})

module.exports = placeRightBelow
